export default {
    update: "Update",
    titleService: "Services",
    titlePlugin: "Plugins",
    columns: {
        name: "Service name",
        version: "Version"
    },
    notification: {
        load_error: "Load error",
        add_ok: "Request send",
        add_error: "Request error",
    },
}